import { NgModule } from "@angular/core";
import {ActionsComponent} from "@app/components/actions/actions.component";
import {
  MedBtnModule,
  MedDatepickerModule,
  MedInputModule,
  MedMultiSelectModule,
  MedPaginationModule,
  MedRadioGroupModule
} from "@mk/med-ui";
import {MedIconCloseModule, MedIconDownloadModule, MedIconHistoryModule, MedIconRefreshModule} from "@mk/med-icons";
import {SidebarModule} from "primeng/sidebar";
import {DatePipe, JsonPipe, NgClass, NgForOf, NgIf, NgStyle} from "@angular/common";
import {PageTitleModule} from "@app/components/page-title/page-title.module";
import {LoaderModule} from "@app/components/loader/loader.module";
import {TableModule} from "primeng/table";
import {FormsModule} from "@angular/forms";

@NgModule({
  declarations: [
    ActionsComponent
  ],
  imports: [
    MedDatepickerModule,
    MedIconCloseModule,
    MedIconHistoryModule,
    MedInputModule,
    MedMultiSelectModule,
    SidebarModule,
    NgStyle,
    PageTitleModule,
    LoaderModule,
    MedPaginationModule,
    MedRadioGroupModule,
    NgForOf,
    NgIf,
    TableModule,
    NgClass,
    DatePipe,
    MedBtnModule,
    MedIconDownloadModule,
    FormsModule,
    JsonPipe,
    MedIconRefreshModule
  ],
  exports: [],
})
export class ActionsModule {}
